import { PUBLIC_PLATFORM_FEATURES } from "./features";
import type { PublicNavContext } from "../publicNavigation";
import type { NavConfig } from "./types";

export function getProductNavConfig(
  ctx: PublicNavContext,
): NavConfig["product"] {
  const { isSwedish, destinations } = ctx;
  return {
    label: isSwedish ? "Plattform" : "Platform",
    overview: isSwedish ? "/plattform" : "/en/platform",
    submenu: {
      layout: "mega",
      overview: {
        label: isSwedish ? "Plattformsöversikt" : "Platform overview",
        href: isSwedish ? "/plattform" : "/en/platform",
        description: isSwedish
          ? "Hela hemtjänstdagen i en plattform"
          : "The whole home-care day in one platform",
      },
      items: [],
      // Seeing the product belongs with the product (owner 2026-10-10).
      groups: [
        {
          label: isSwedish ? "Alla funktioner" : "All features",
          items: PUBLIC_PLATFORM_FEATURES.filter(
            (feature) => feature.key !== "integrations",
          ).map((feature) => ({
            label: feature.label[isSwedish ? "sv" : "en"],
            href: feature.paths[isSwedish ? "sv" : "en"],
          })),
        },
        {
          label: isSwedish ? "Integrationer" : "Integrations",
          href: isSwedish
            ? "/plattform/integrationer"
            : "/en/platform/integrations",
          items: [
            {
              label: isSwedish
                ? "Utvecklare & integrationer"
                : "Developers & integrations",
              href: isSwedish
                ? "/resurser/utvecklare"
                : "/en/resources/developers",
              description: isSwedish
                ? "API, Swagger, MCP och arkitektur"
                : "API, Swagger, MCP and architecture",
            },
          ],
        },
        {
          label: isSwedish ? "Se Caire" : "See Caire",
          items: [
            {
              label: isSwedish ? "Interaktiv demo" : "Interactive demo",
              href: isSwedish
                ? "/produkt/interaktiv-demo"
                : "/en/product/interactive-demo",
              description: isSwedish
                ? "Klicka dig igenom planeringen, utan inloggning"
                : "Click through the planning, no login",
            },
            {
              label: isSwedish ? "Produktfilm" : "Product film",
              href: isSwedish ? "/produkt/film" : "/en/product/film",
            },
            {
              label: isSwedish
                ? "Kundpresentation: Caire för hemtjänst"
                : "Customer presentation: Caire for home care",
              href: isSwedish
                ? "/resurser/kundpresentation/caire-for-hemtjanst.html"
                : "/en/resources/customer-presentation/caire-for-hemtjanst.html",
              reloadDocument: true,
            },
          ],
        },
      ],
    },
    primaryLinks: [
      {
        label: isSwedish ? "Plattform" : "Platform",
        href: isSwedish ? "/plattform" : "/en/platform",
        description: isSwedish
          ? "Hela hemtjänstdagen i en plattform"
          : "The whole home-care day in one platform",
      },
      {
        label: isSwedish ? "Interaktiv demo" : "Interactive demo",
        href: isSwedish
          ? "/produkt/interaktiv-demo"
          : "/en/product/interactive-demo",
        description: isSwedish
          ? "Klicka dig igenom dashboarden och mobilapparna – ingen inloggning"
          : "Click through the dashboard and mobile apps — no login",
      },
    ],
    sections: {
      features: {
        label: isSwedish ? "Funktioner" : "Features",
        href: isSwedish ? "/plattform" : "/en/platform",
        description: isSwedish
          ? "Alla funktioner från plattformsöversikten"
          : "All features from the platform overview",
        items: [],
      },
      users: {
        label: isSwedish ? "Användare" : "Users",
        href: isSwedish ? "/losningar" : "/en/solutions",
        items: [
          {
            label: isSwedish ? "Privat hemtjänst" : "Private home-care",
            href: isSwedish
              ? "/losningar/privat-hemtjanst"
              : "/en/solutions/private-home-care",
          },
          {
            label: isSwedish ? "Hemtjänstkedja" : "Home-care chain",
            href: isSwedish
              ? "/losningar/hemtjanstkedja"
              : "/en/solutions/home-care-chain",
          },
          {
            label: isSwedish ? "Samordnare" : "Scheduler",
            href: isSwedish
              ? "/losningar/samordnare"
              : "/en/solutions/scheduler",
          },
          {
            label: isSwedish ? "Verksamhetschef" : "Operations manager",
            href: isSwedish
              ? "/losningar/verksamhetschef"
              : "/en/solutions/operations-manager",
          },
        ],
      },
    },
    description: isSwedish
      ? "Planering, analys och rekommendationer i ett arbetsflöde"
      : "Planning, analytics, and recommendations in one workflow",
    cta: {
      label: destinations.signupLabel(isSwedish ? "sv" : "en"),
      href: destinations.productSignupHref,
    },
  };
}
